import axiosInstance from '@/utils/axios';
import { handleApiError } from '@/utils/helpers';

// @ List licenses with bindings
// @ uses user auth token
export const licenseList = async (payload) => {
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/license_list`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// @ List license details with bindings
// @ field: id - this is the license id
export const licenseGet = async (payload) => {
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/license_get`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// @ Admin List license details with bindings
// @ field: id - this is the license id
export const adminLicenseGet = async (payload) => {
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/admin_license_get`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// @ Disable apex license binding
// @ field: id - this is the id of the binding, not the license id
export const licenseBindingDisable = async (payload) => {
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/license_binding_disable`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};
